import axios from "axios";
let source = null;

export default {
  getWalloniaStreets(idTown, search, lang) {
    const CancelToken = axios.CancelToken;
    source = CancelToken.source();

    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `https://geoservices.wallonie.be/geocodeWS/geolist`,
        params: {
          city: idTown,
          street: search,
          lang: lang,
        },
        cancelToken: source.token
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getWalloniaZone(zipCode) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `https://geoservices.wallonie.be/geocodeWS/geolist`,
        params: { zone: zipCode }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getStreets(search) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `https://geo.api.vlaanderen.be/geolocation/v2/Suggestion`,
        params: {q:search}
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  cancelRequest() {
    if (source) {
      source.cancel('The request has been cancelled by the user.');
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/streetService.js